export function Processing() {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center p-4">
      <div className="text-center">
        <div className="w-16 h-16 border-4 border-brand-500 border-t-transparent rounded-full animate-spin mx-auto mb-6" />
        <h2 className="text-xl font-semibold text-gray-900 mb-2">Procesando pago</h2>
        <p className="text-gray-500">Por favor espera un momento...</p>
      </div>
    </div>
  );
}
